// extracted by mini-css-extract-plugin
module.exports = {"root":"📦UserDetailModify__root--330Di","labelledValue":"📦UserDetailModify__labelledValue--2a4JV","labelledSelect":"📦UserDetailModify__labelledSelect--3e51m"};